import { Button, Flex, Icon, Text, Title } from '@bb/elements-web';
import { Modal } from 'components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import BookingTimeSelectContext from './BookingTimeSelectContext';

const RestrictedTimeModal: React.FC = () => {
  const { restrictedTimeData, setRestrictedTimeData } = useContext(
    BookingTimeSelectContext,
  );

  return (
    <Modal
      title={
        <Flex gap="middle" align="center">
          <Icon icon="warningOutlined" size={24} color="warning" />
          <StyledTitle level={3} dataCy="restrictedTimeModal-title">
            Restricted time slot
          </StyledTitle>
        </Flex>
      }
      footer={
        <Flex justify="space-around">
          <Button
            dataCy="cancelRestrict-btn"
            type="secondary"
            onClick={() => {
              restrictedTimeData.onCancel();
              setRestrictedTimeData({
                isModalOpen: false,
                onCancel: () => null,
                onOk: () => null,
              });
            }}
          >
            Cancel
          </Button>{' '}
          <Button
            dataCy="yesRestrict-btn"
            onClick={() => {
              restrictedTimeData.onOk();
              setRestrictedTimeData({
                isModalOpen: false,
                onCancel: () => null,
                onOk: () => null,
              });
            }}
          >
            Yes
          </Button>
        </Flex>
      }
      centered
      closable={false}
      open={restrictedTimeData.isModalOpen}
      data-cy="restrictedTime-modal"
    >
      <StyledText size="large">
        You have selected a restricted time slot. Are you sure?
      </StyledText>
    </Modal>
  );
};

const StyledTitle = styled(Title)`
  && {
    margin: 0;
  }
`;

const StyledText = styled(Text)`
  text-align: center;
`;

export default RestrictedTimeModal;
